import script from "./CUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./CUpload.vue?vue&type=script&setup=true&lang=ts"

import "./CUpload.vue?vue&type=style&index=0&id=ace98bbc&lang=scss&scoped=true"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ace98bbc"]])

export default __exports__